export const ENTITY_SANDBOXES_PATH = '/:entityName/sandboxes';
